<template>
    <ul
      v-if="results && results.length > 0"
      :class="['dropdown-menu', { show: isOpen }]"
      id="dropdown-menu-search"
      aria-labelledby="navbarDropdown_search">
      <li v-for="(item, i) of results" :key="i" :class="{ active: currentItem === i }">
        <a class="dropdown-item" :href="link(item)">
          {{ $helpers.getLocalizedField(item, 'value') }}
        </a>
      </li>
    </ul>
     <!-- Dropdown links list end -->
</template>
<script>
export default {
  name: 'DropDownSearch',
  props: ['is-open', 'results'],

  mounted () {
    document.addEventListener('keydown', this.nextItem)
  },

  watch: {
    results (val) {
      this.currentItem = 0
    }
  },

  data () {
    return {
      currentItem: 0
    }
  },

  methods: {
    nextItem (event) {
      if (event.keyCode === 38 && this.currentItem > 0) {
        this.currentItem--
      } else if (event.keyCode === 40 && this.currentItem < this.results.length - 1) {
        this.currentItem++
      } else if (event.keyCode === 13) {
        window.location.href = this.link(this.results[this.currentItem])
      }
    },

    link (item) {
      return item.is_student ? `/profile/student/${item.id}` : `/profile/person/${item.id}`
    }
  }
}
</script>
<style scoped>
.active {
  border: 1px solid #6e9faa;
  background-color: #6e9faa11;
  border-radius: 10px;
}

.active a {
  font-weight: bold;
}

#dropdown-menu-search, .dropdown-item {
  max-width: 300px;
  font-size: 12px;
}
</style>
